import { LOCAL_STORAGE_EMAIL_SEARCH_CONDITIONS_KEY } from "constants/local-storage-keys";
import type { EmailSearchInput } from "hooks/useEmailsRestApi";

/**
 * メール検索条件をlocalStorageに保存・復元するUtilityクラス
 */
export class SearchConditionsStorage {
  /**
   * 検索条件をlocalStorageに保存する
   * @param {EmailSearchInput} conditions - 検索条件
   * @param {boolean} isMatter - 案件/人材の選択状態
   */
  static saveSearchConditions(
    conditions: EmailSearchInput,
    isMatter: boolean,
  ): void {
    try {
      const searchData = {
        conditions,
        isMatter,
        timestamp: Date.now(),
      };
      localStorage.setItem(
        LOCAL_STORAGE_EMAIL_SEARCH_CONDITIONS_KEY,
        JSON.stringify(searchData),
      );
    } catch (_error) {
      // エラーを無視
    }
  }

  /**
   * 保存された検索条件をlocalStorageから読み込む
   * @return {Object} 検索条件とisMatterの状態。保存されていない場合はnull
   * @return {EmailSearchInput | null} return.conditions - 検索条件
   * @return {boolean | null} return.isMatter - 案件/人材の選択状態
   */
  static loadSearchConditions(): {
    conditions: EmailSearchInput | null;
    isMatter: boolean | null;
  } {
    try {
      const saved = localStorage.getItem(
        LOCAL_STORAGE_EMAIL_SEARCH_CONDITIONS_KEY,
      );
      if (!saved) {
        return { conditions: null, isMatter: null };
      }

      const searchData = JSON.parse(saved);

      // 24時間以内のデータのみ有効とする
      const twentyFourHours = 24 * 60 * 60 * 1000;
      if (Date.now() - searchData.timestamp > twentyFourHours) {
        SearchConditionsStorage.clearSearchConditions();
        return { conditions: null, isMatter: null };
      }

      return {
        conditions: searchData.conditions,
        isMatter: searchData.isMatter,
      };
    } catch (_error) {
      return { conditions: null, isMatter: null };
    }
  }

  /**
   * 保存された検索条件をlocalStorageから削除する
   */
  static clearSearchConditions(): void {
    try {
      localStorage.removeItem(LOCAL_STORAGE_EMAIL_SEARCH_CONDITIONS_KEY);
    } catch (_error) {
      // エラーを無視
    }
  }
}
